import script from "./DeleteCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteCustomer.vue?vue&type=script&setup=true&lang=js"

import "./DeleteCustomer.vue?vue&type=style&index=0&id=0e87ec79&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e87ec79"]])

export default __exports__